import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// The employee list (Operators page), fetched once and shared: pick-lists on the production sheets use it.
let cache = null;
let pending = null;
const load = () => (pending ||= api.get("/operators").then(({ data }) => (cache = data)).catch(() => (cache = [])).finally(() => { pending = null; }));

// Departments that run a machine: the only people offered where an operator is picked for a job or run.
export const MACHINE_DEPTS = ["Printing", "Printing IPQC", "Slitting"];

/** Active employees, optionally only those of the given departments (e.g. ["Printing", "Printing IPQC"]). */
export function useEmployees(departments) {
  const [rows, setRows] = useState(cache || []);
  useEffect(() => { load().then(setRows); }, []);
  return rows.filter((e) => e.status !== "inactive" && (!departments || departments.includes(e.department)));
}
